export const difficulty = {
  0: "#757373",
  1: "#fbd400",
  2: "#b5e352",
  3: "#729eeb",
  4: "#bc70c4",
};
